




























































import Vue from 'vue'
import cloneDeep from 'lodash/cloneDeep'
import { BaseBtnCancel, BaseBtnSave } from '@/components'
import { IShippingAddress } from '@/models'
import { ruleNotEmptyString } from '@/utils'
import { createNamespacedHelpers } from 'vuex'
import { STORE_MODULES, MUTATIONS_ORDER } from '@/enums'

const { mapMutations } = createNamespacedHelpers(STORE_MODULES.ORDER)

export default Vue.extend({
    name: 'DialogAddressForm',

    components: { BaseBtnCancel, BaseBtnSave },

    model: {
        prop: 'isFormShown',
        event: 'update:is-form-shown',
    },

    props: {
        isFormShown: {
            type: Boolean,
            required: true,
        },
        address: {
            type: Object as () => IShippingAddress,
            required: true,
        },
    },

    data: () => ({
        newAddress: undefined as undefined | IShippingAddress,
    }),

    created() {
        this.newAddress = cloneDeep(this.address)
    },

    methods: {
        ...mapMutations({ setShippingAddress: MUTATIONS_ORDER.SET_SHIPPING_ADDRESS }),

        cancel(): void {
            this.hideForm()
        },

        submit(): void {
            if (!(this.$refs.form as any).validate()) return

            this.setShippingAddress(this.newAddress)
            this.hideForm()
        },

        hideForm(): void {
            this.$emit('update:is-form-shown', false)
        },

        ruleNotEmptyString,
    },
})
